import React from 'react';
import templateLibrary from '../../../../assets/icons/template-library.svg';
import eSignature from '../../../../assets/icons/e-signature.svg';
import aiContract from '../../../../assets/icons/ai-contract.svg';
import collaboration from '../../../../assets/icons/collaboration.svg';
import security from '../../../../assets/icons/security.svg';
import contractManagement from '../../../../assets/icons/contract-management.svg';

const features = [
  {
    icon: <img src={templateLibrary} alt="Template Library" className="kf-icon" />, // blue bg
    title: 'TEMPLATE LIBRARY',
    desc: 'Access a growing library of professional contract templates',
    iconBg: 'cf-bg-blue',
  },
  {
    icon: <img src={eSignature} alt="E-Signatures" className="kf-icon" />, // green bg
    title: 'E-SIGNATURES',
    desc: 'Collect legally binding electronic signatures securely',
    iconBg: 'cf-bg-green',
  },
  {
    icon: <img src={aiContract} alt="AI Contract Analysis" className="kf-icon" />, // orange bg
    title: 'AI CONTRACT ANALYSIS',
    desc: 'Get insights and risk assessment on contract terms',
    iconBg: 'cf-bg-orange',
  },
  {
    icon: <img src={collaboration} alt="Collaboration" className="kf-icon" />, // purple bg
    title: 'COLLABORATION',
    desc: 'Real-time editing and commenting with team members',
    iconBg: 'cf-bg-purple',
  },
  {
    icon: <img src={security} alt="Security & Compliance" className="kf-icon" />, // pink bg
    title: 'SECURITY & COMPLIANCE',
    desc: 'Enterprise-grade security for all your legal documents',
    iconBg: 'cf-bg-pink',
  },
  {
    icon: <img src={contractManagement} alt="Contract Management" className="kf-icon" />, // pink bg
    title: 'CONTRACT MANAGEMENT',
    desc: 'Track statuses, renewals, and key contract dates',
    iconBg: 'cf-bg-pink',
  },
];

const ContractFeatures = () => (
  <section className="key-features">
    <div className="container">
      <div className="key-features-header">
        <h2 className="key-features-header-title">KEY FEATURES</h2>
        <p className="key-features-header-subtitle">
          Everything you need to streamline your document collection and management
        </p>
        <div className="key-features-grid">
          {features.map((f, i) => (
            <div className="key-feature-card" key={i}>
              <div className={`icon-wrapper ${f.iconBg}`}>{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ContractFeatures;
